import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../components/mybids/mybids.css";
import { useNavigate } from "react-router-dom";
import placeimg from "../../myimgs/Group 193.png";
import Swal from "sweetalert2";

const Favorites = () => {
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const handleViewDetails = (id, propeId, listedBy, email) => {
    const encodedListedBy = encodeURIComponent(listedBy || "");
    const encodedEmail = encodeURIComponent(email || "");
    // Open the route in a new tab with query params
    const url = `/propertyDetail?id=${id}&propeId=${propeId}&listedBy=${encodedListedBy}&email=${encodedEmail}`;
    window.open(url, "_blank");
  };
  useEffect(() => {
    const fetchFavorites = async () => {
      const userId = localStorage.getItem("userId");
      if (!userId) return;

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/favorites/${userId}`,
        );
        setFavorites(response.data.data || []);
      } catch (error) {
        console.error("Error fetching favorites:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFavorites();
  }, []);
  // timersss  ...
  function Countdown({ start, end }) {
    const [timeLeft, setTimeLeft] = useState("");

    const formatDateTime = (dateString) => {
      const date = new Date(dateString);
      if (isNaN(date)) return "";
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${day}-${month}-${year}, ${hours}:${minutes}`;
    };

    const getRemainingTime = (startTime, endTime) => {
      if (!startTime || !endTime) return "";

      const now = new Date();
      const startDate = new Date(startTime);
      const endDate = new Date(endTime);

      if (isNaN(startDate) || isNaN(endDate)) return "";

      // Before start
      if (now < startDate) {
        return (
          <>
            Starts In:
            <br />
            {formatDateTime(startDate)}
          </>
        );
      }

      const diff = endDate - now;
      if (diff <= 0) return "Ended";

      // When started, show Ends In
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      return (
        <>
          Ends In:
          <br />
          {`${days}D : ${hours}H : ${minutes}M : ${seconds}s`}
        </>
      );
    };

    useEffect(() => {
      const interval = setInterval(() => {
        setTimeLeft(getRemainingTime(start, end));
      }, 1000);

      return () => clearInterval(interval);
    }, [start, end]);

    return <h3>{timeLeft || ""}</h3>;
  }
  const toggleFavorite = async (propeId, propertyId, listingId) => {
    const userId = localStorage.getItem("userId");

    if (!userId) {
      Swal.fire({
        title: "Login Required",
        text: "Please login first to add properties to your favorites.",
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#3085d6",
      });
      return;
    }

    // optimistic UI
    setFavorites((prev) =>
      prev.includes(propertyId)
        ? prev.filter((favId) => favId !== propertyId)
        : [...prev, propertyId],
    );

    try {
      const baseURL = process.env.REACT_APP_API_BASE_URL;
      let url = "";

      // if (propertyId && propertyId !== "null" && propertyId !== "") {
      //   url = `${baseURL}/favorites/mark?userId=${userId}&propertyId=${propertyId}`;
      // } else if (listingId) {
      //   url = `${baseURL}/favorites/mark?userId=${userId}&listingId=${listingId}`;
      // } else {
      //   console.error("Both propertyId and listingId are missing");
      //   return;
      // }
      console.log("prop...........", propeId);

      if (propeId && propeId !== "null" && propeId !== "") {
        url = `${baseURL}/favorites/mark?userId=${userId}&propertyId=${propertyId}`;
      } else {
        url = `${baseURL}/favorites/mark?userId=${userId}&listingId=${listingId}`;
      }

      const response = await axios.post(url);

      if (response.status === 200) {
        console.log("Favorite updated successfully:", response.data);
      }
    } catch (error) {
      console.error("Error updating favorite:", error);
    }
  };
  // timersss  ...
  return (
    <div className="auction-container">
      <h2 className="auction-title">My Watchlist Properties</h2>
      {!loading && !favorites.length && (
        <p style={{ textAlign: "center", marginTop: "10px" }}>No data found</p>
      )}

      <div className="auction-list">
        {favorites.map((fav) => (
          <div key={fav.id} className="auction-card kjui">
            {/* Image */}
            <img
              src={
                fav.propertyImages?.[0]?.imageUrl
                  ? fav.propertyImages[0].imageUrl
                  : placeimg
              }
              alt="Property"
            />

            <div className="auction-info">
              <div className="auction-details">
                
                {(fav.listingId || fav.propeId) && (
                  <h3 className="mls">
                    {fav.listingId ? (
                      <>
                        <strong>MLS No:</strong> {fav.listingId}
                      </>
                    ) : (
                      <>
                        <strong>Property Id:</strong> {fav.propeId}
                      </>
                    )}
                  </h3>
                )}
                <p className="listed-by">
                  Listed by <span>{fav.user?.name}</span>
                </p>

                {/* Address */}
                <h3 className="address">{fav.unparsedAddress}</h3>

                <div className="property-specs">
                  {fav.bedroomsTotal > 0 && (
                    <span className="spec">🛏{fav.bedroomsTotal}bed</span>
                  )}

                  {fav.bathroomsTotalInteger > 0 && (
                    <span className="spec">
                      🛁{fav.bathroomsTotalInteger}bath
                    </span>
                  )}

                  {fav.lotSizeArea > 0 && (
                    <span className="spec">📐{fav.lotSizeArea}ft</span>
                  )}
                </div>

                {/* Countdown Timer */}
                <div className="timebtn lko">
                  <Countdown
                    start={fav.biddingDetails?.bidingStartDateTime}
                    end={fav.biddingDetails?.bidingEndDateTime}
                  />
                </div>
              </div>

              <div className="price-section">
                {/* <div className="auctions-image favimpouio">
                  <div
                    className="fav-icon"
                    onClick={() =>
                      toggleFavorite(fav.propeId, fav.id, fav.listingId)
                    }
                    style={{
                      cursor: "pointer",
                      borderRadius: "50%",
                      padding: "6px",
                    }}
                  >
                    <i
                      className={`fa${
                        favorites.includes(fav.id) ? "s" : "r"
                      } fa-heart`}
                      style={{
                        color: favorites.includes(fav.id) ? "red" : "#ccc",
                        fontSize: "27px",
                        transition: "color 0.2s ease",
                      }}
                    ></i>
                  </div>
                </div> */}
                {/* <p className="price-label">Current Valuation</p> */}
                <p className="price-label">
                  {fav.biddingDetails == null
                    ? "Listing Price"
                    : fav.isBidEnd === false
                      ? "Listing Price"
                      : "Current Offer Price"}
                </p>
                <h4 className="prices">
                  {(() => {
                    const details = fav.biddingDetails;

                    // CASE 1: If biddingDetails exists
                    if (details) {
                      // If bid has ended → show listPrice
                      if (
                        details.isBidEnd !== null &&
                        details.isBidEnd === true
                      ) {
                        return `$${Number(fav.listPrice).toLocaleString()}`;
                      }

                      // If bid NOT ended → show currentAuctionAmount OR offerStartingPrice
                      return `$${Number(
                        details.currenntAuctionAmount ??
                          details.offerStartingPrice,
                      ).toLocaleString()}`;
                    }

                    // CASE 2: If biddingDetails does NOT exist → show listPrice
                    return `$${Number(fav.listPrice).toLocaleString()}`;
                  })()}
                </h4>

                <button
                  className="view-btn"
                  onClick={() => {
                    const listedBy =
                      fav.user?.name || fav.originatingSystemName;
                    const email = fav.user?.email || "";
                    handleViewDetails(fav.id, fav.propeId, listedBy, email);
                  }}
                >
                  View Details
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Favorites;
